import { ShieldCheck } from "lucide-react";

// Stripe Identity (18+) verified badge — shown next to names across the app.
export function VerifiedBadge({ user, size = "sm", testId }) {
  if (!user?.age_verified) return null;
  if (size === "lg") {
    return (
      <span data-testid={testId} title="Identity verified · 18+"
        className="inline-flex items-center gap-1 text-xs uppercase tracking-[0.15em] text-gold border border-gold/40 bg-gold/10 px-3 py-1.5 rounded-full">
        <ShieldCheck size={14} /> Verified
      </span>
    );
  }
  return (
    <span data-testid={testId} title="Identity verified · 18+"
      className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.12em] text-gold shrink-0">
      <ShieldCheck size={size === "xs" ? 12 : 16} className="fill-gold/15" /> {size === "xs" ? "" : "Verified"}
    </span>
  );
}
